/**
 * Single central place to toggle a compile-time feature flag for release.
 * Changing a value here (then rebuild + redeploy) releases or withdraws the feature;
 * no other file needs to change.
 *
 * The resolver can later be swapped to fetch from a backend `/api/features` endpoint
 * without changing call sites, which only ever call `featureFlags.isEnabled(...)`.
 *
 * See docs/DevinDocs/FEATURE_FLAGS.md for usage, release steps and future sources.
 */

export type FeatureFlagKey = 'lazyLoad' | 'planAvailabilitySummary' | 'yearMonthSummary';

const FEATURE_FLAGS: Record<FeatureFlagKey, boolean> = {
  lazyLoad: true,
  planAvailabilitySummary: true,
  yearMonthSummary: true,
};

export const featureFlags = {
  isEnabled(flag: FeatureFlagKey): boolean {
    return FEATURE_FLAGS[flag] ?? false;
  },
};
